import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupbyF'
})
export class GroupbyFPipe implements PipeTransform {

  transform(collection: any[], property: string): any[] {
    if (!collection || !property) return collection;

    const grouped = collection.reduce((acc, item) => {
      const key = item[property];
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    return Object.keys(grouped).map(key => ({ key, items: grouped[key] }));
  }

}
